import * as Yup from "yup";

export const passwordFormValidationSchema = Yup.object().shape({
    password: Yup.string().required("Password is required!"),
    confirmPassword: Yup.string().ensure().when('id', {
        is: (customerId) => !customerId,
        then: Yup.string().required("Confirm Password is required!")
            .oneOf([Yup.ref('password')], 'Passwords must match')
    }),
})